import { React, useState } from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";

const NewsItem = ({ Tr, handleNavigation }) => {
    const [logoError, setLogoError] = useState(false);

    return (
        <Box
            className="item-caroselNews"
            style={{padding : '0'}}
            key={Tr.name}
            onClick={() => handleNavigation(Tr.url)}
        >

                <div className="final-logo-container" style={{alignContent:'center',minHeight:'30px',margin:'0 40px'}}>
                    <Typography
                        sx={{
                            fontSize: `14px`,
                            color: "#ffffff",
                        }}
                        className="final-logo"
                    >
                        {Tr?.name}
                    </Typography>
                </div>

        </Box>
    );
};

const News = ({ trusted }) => {
    const navigate = useNavigate();

    const handleNavigation = (uuid) => {
        if (uuid != null)
        window.open(`${window.location.origin}${uuid}`, '_blank', 'noopener,noreferrer');
        // navigate(`/AdsPanelsDetails/${uuid}`);
    };

    if (!trusted?.length) return null;

    return (
        <Box>


            <Box
                className="carouselNews"
                sx={{ marginTop: "0px" ,background:"#4ea27d"}}
                onMouseEnter={() => {
                    document.querySelector(".carouselNews-inner").style.animationPlayState = "paused";
                }}
                onMouseLeave={() => {
                    document.querySelector(".carouselNews-inner").style.animationPlayState = "running";
                }}
            >
                <Box className="carouselNews-inner">
                    {/* Original items */}
                    {trusted.map((Tr) => (
                        <NewsItem key={Tr.name} Tr={Tr} handleNavigation={handleNavigation} />
                    ))}

                    {/* Duplicated items for infinite scroll effect */}
                    {trusted.map((Tr) => (
                        <NewsItem key={`repeat-${Tr.name}`} Tr={Tr} handleNavigation={handleNavigation} />
                    ))}
                </Box>
            </Box>
        </Box>
    );
};

export default News;